module.exports = __webpack_public_path__ + "media/images/apple-icon-152x152-c72986b9.png";